import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { workspacesQueryKey } from '../workspaces/useWorkspaces'
import { locationsQueryKey } from './useLocations'

import type { WorkspaceLocation, Workspace } from 'honeygrid-types'

interface RemoveLocationParams {
	workspaceId?: Workspace['uuid']
	locationId: WorkspaceLocation['uuid']
}

export const useRemoveLocationFromWorkspace = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: ({ workspaceId, locationId }: RemoveLocationParams) =>
			authFetch(`workspaces/${workspaceId}/locations/${locationId}`, {
				method: 'DELETE',
			}) as Promise<Workspace>,
		onSuccess: (_, { workspaceId }) => {
			// Invalidate workspaces (location count might change)
			queryClient.invalidateQueries({ queryKey: workspacesQueryKey() })
			// Invalidate locations list for workspace
			queryClient.invalidateQueries({ queryKey: locationsQueryKey(workspaceId) })
		},
	})
}
